import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function three_column_cards_large() {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: ".three_column_cards_large",
    start: "top top",
    end: "+=1000",
    pin: true,
    pinSpacing: true,
    scrub: true,
  });

  // Animate cards in one by one when pinned
  gsap.from(".three_column_cards_large .card", {
    scrollTrigger: {
      trigger: ".three_column_cards_large",
      start: "top top",
      end: "120%",
      scrub: true,
    },
    opacity: 0,
    y: 100,
    stagger: 0.2,
    duration: 1,
    ease: "power3.out",
  });
}
